export default __webpack_public_path__ + "3043606777f487e0dadd43c78705da4b.png";